export const getGeneratorsUrl = ({
  title,
  generatorId,
}: {
  title?: string | null;
  generatorId: string;
}) => {
  if (title) return `/generators/${sanitizeString(title)}/g/${generatorId}`;
  return `/generators/Untitled/g/${generatorId}`;
};

function sanitizeString(input: string): string {
  return input
    .toLowerCase() // Convert the string to lowercase
    .replace(/\s+/g, '-') // Replace spaces with dashes
    .replace(/[^a-z\-]/g, ''); // Remove all characters that are not [a-z] or dash
}
